import React, { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import { t, Trans } from '@lingui/macro';
import { i18n } from '@lingui/core';
import {LanguageSelector} from '../languageDetection';

const Layout = ({ children }: PropsWithChildren<unknown>) => {

    return (
        <>
            <header className="nav d-flex px-3">
                <div className="d-flex w-100 justify-content-between align-items-center gap-lg-5 pe-2">
                    <div className="d-flex align-items-center gap-4">
                        <a className="logo py-auto" href="https://www.ptvgroup.com">
                            <div>
                                <img alt="PTV Group Logo" className="logo-img" height="50" src="/license-wizard/PTV_Group_Umovity.svg" />
                            </div>
                            <meta content="PTV Group" />
                        </a>
                        <div className="brand d-none d-lg-block">
                            <div className="brand-title d-flex align-items-center gap-2 ">                            
                                <Link to={i18n.locale ? '/' + i18n.locale : '/'} replace={true} >
                                    <Trans>PTV License Support</Trans>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="wrapper-nav-main d-none d-lg-flex flex-grow-1 flex-shrink-1">                        
                    </div>
                    <div className="d-flex gap-2">
                        <LanguageSelector />
                    </div>
                </div>
            </header>
            <div className="wrapper-page">
                <section className="wrapper-main">
                    <main role="main">
                        <div> {children}</div>
                        <footer className="footer">
                            <div className="wrapper-imprint">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12">
                                            <ul>
                                                <li><Trans>© PTV Planung Transport Verkehr GmbH 2024</Trans></li>
                                                <li><a href={t`https://www.ptvgroup.com/en/terms-privacy/`} rel="noreferrer" target="_blank">{t`Terms & Privacy`}</a></li>
                                                <li><a href={t`https://www.ptvgroup.com/en/imprint/`} rel="noreferrer" target="_blank">{t`Imprint`}</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </footer>
                    </main>
                </section>
            </div>
        </>
    );
};

export default Layout;